import { OktaAuth } from '@okta/okta-auth-js';
import sampleConfig from '@/config';

const oktaAuth = new OktaAuth(sampleConfig.oidc);
export default oktaAuth;